import { ALL_FILTER } from '../stock/stockConstants';
import { MOVEMENT_TYPE_LABELS } from '../../utils/inventoryLabels';

/** "Nobody": the movements the system wrote on its own (a signal, a sync). */
export const SYSTEM_ACTOR = 'none';

/** The movement types to filter by, in Spanish, with "Todos" first. */
export const MOVEMENT_TYPE_OPTIONS = [
  { value: ALL_FILTER, label: 'Todos' },
  ...Object.entries(MOVEMENT_TYPE_LABELS).map(([value, label]) => ({ value, label })),
];

/**
 * The "quién" options: everyone who left a movement, and "Sistema" when some
 * movement has no actor. Values are strings because the select compares them
 * as such; the thunk turns an id back into a number for the server.
 *
 * @param {Array<{id: number, email: string}>} actors
 * @param {boolean} hasSystem
 * @returns {Array<{value: string, label: string}>}
 */
export const actorOptions = (actors = [], hasSystem = false) => [
  { value: ALL_FILTER, label: 'Todos' },
  ...actors.map((actor) => ({ value: String(actor.id), label: actor.email })),
  ...(hasSystem ? [{ value: SYSTEM_ACTOR, label: 'Sistema' }] : []),
];

/** The filters that narrow the listing, to say "no match" instead of "no history". */
export const isFiltering = (filters) =>
  Boolean(
    filters.search ||
      filters.slot ||
      filters.company !== ALL_FILTER ||
      filters.movementType !== ALL_FILTER ||
      filters.actor !== ALL_FILTER ||
      filters.dateFrom ||
      filters.dateTo
  );

/**
 * What the server is asked for, from the slice's filters and the warehouse in
 * use. Only what narrows travels: "Todos" is the absence of the parameter.
 */
export const buildMovementsParams = (filters, warehouseId) => {
  const params = { page: filters.page, page_size: filters.rowsPerPage };
  if (warehouseId) params.warehouse = warehouseId;
  if (filters.search) params.search = filters.search;
  if (filters.slot) params.slot_search = filters.slot;
  if (filters.company !== ALL_FILTER) params.company = filters.company;
  if (filters.movementType !== ALL_FILTER) params.movement_type = filters.movementType;
  if (filters.actor !== ALL_FILTER) {
    params.actor = filters.actor === SYSTEM_ACTOR ? SYSTEM_ACTOR : Number(filters.actor);
  }
  if (filters.dateFrom) params.date_from = filters.dateFrom;
  if (filters.dateTo) params.date_to = filters.dateTo;
  return params;
};

/** `occurred_at` as "05-10-2026 14:30", in the local time of whoever reads it. */
export const formatMovementMoment = (value) =>
  value
    ? new Date(value).toLocaleString('es-CL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '-';
